import {
  SECTION_YEARLY_CLOSING_COMPANY,
  SECTION_YEARLY_CLOSING_GROUP,
} from '../../constants/sections'

const docConfig = {
  [SECTION_YEARLY_CLOSING_COMPANY]: ['KYC_COMPANY_FINANCIALS', 'KYC_COMPANY_INTERIM_FINANCIALS'],
  [SECTION_YEARLY_CLOSING_GROUP]: [
    'KYC_GROUP_COMPANY_FINANCIALS',
    'KYC_GROUP_COMPANY_INTERIM_FINANCIALS',
  ],
}

const getFinancialDocsBySection = (data, sectionName) =>
  data?.filter(item => docConfig[sectionName]?.includes(item.documentType))

export const getSortedFinacialDocBySection = (data, sectionName) => {
  const filteredData = getFinancialDocsBySection(data, sectionName)

  const dataByYear = filteredData.reduce((finalObj, item) => {
    let modifiedObj
    const dateTo = new Date(item.dateTo)
    const yearTo = dateTo?.getFullYear()

    // when year is already a key
    if (Object.keys(finalObj).includes(yearTo.toString())) {
      modifiedObj = {
        ...finalObj,
        // sorting to show data always in same order
        [yearTo]: [...finalObj[yearTo], item].sort((a, b) =>
          a?.documentType > b?.documentType ? 1 : -1
        ),
      }
    } else {
      // when new item
      modifiedObj = {
        ...finalObj,
        [yearTo]: [item],
      }
    }
    return modifiedObj
  }, {})
  const availableYears = Object.keys(dataByYear).sort((a, b) => b - a)

  return {
    ...dataByYear,
    availableYears,
  }
}
